export const ASSETS_DOMAIN = 'https://cdn.greatwolf.com';

export const ASSETS_LOCATIONS = {
  ROOT: '{ASSETS_DOMAIN}/{FILE_NAME}',
  CONTENT: '{ASSETS_DOMAIN}/content/{FILE_NAME}',
  GIFS: '{ASSETS_DOMAIN}/content/gifs/{FILE_NAME}',
  JPG: '{ASSETS_DOMAIN}/content/jpg/{FILE_NAME}',
  JS: '{ASSETS_DOMAIN}/content/js/{FILE_NAME}',
  PNG: '{ASSETS_DOMAIN}/content/png/{FILE_NAME}',
  SVG: '{ASSETS_DOMAIN}/content/svg/{FILE_NAME}',
  WEBP: '{ASSETS_DOMAIN}/content/webp/{FILE_NAME}',
  VIDEO: '{ASSETS_DOMAIN}/content/video/{FILE_NAME}',
  ANIMATION: '{ASSETS_DOMAIN}/content/animations/{FILE_NAME}'
};

export const getAssetsUrl = (url, file) => {
  return url?.replace('{ASSETS_DOMAIN}', ASSETS_DOMAIN)?.replace('{FILE_NAME}', file);
};

export const PRICING_KEY_ERROR_TYPES = ['CRS006', 'CRS021', 'CRS022', 'CRS023'];
export const NO_INVENTORY_ERROR_TYPE = 'CRS009';

export const CHECKIN_TIME = '4 p.m.';
export const SITE_NIAGON = 'NIAGON';
export const SITE_POCOPA = 'POCOPA';
export const NO_PROMO_CODE = 'BBAR';

export const RESERVATION_STATUS = {
  canceled: 'CANCELED',
  checkedOut: 'CHECKEDOUT'
};

export const LATE_CHECKOUT_PREFIXES = {
  code: 'LCO',
  itemCode: 'LCO'
};

export const SEASON_PASS_TYPES = {
  WEEKDAY: 'WEEKDAY',
  ANYTIME: 'ANYTIME'
};

export const WEEKDAY_SEASON_PASS_BENEFITS = [
  'Free Entry from Monday to Friday.',
  'All water park amenities included',
  'Visit as often as you want—only pay once'
];

export const PERRYVILLE_WEEKDAY_SEASON_PASS_BENEFITS = [
  'Free Entry from Monday to Thursday.',
  'All water park amenities included',
  'Visit as often as you want—only pay once'
];

export const ANYTIME_SEASON_PASS_BENEFITS = [
  'Free entry for all visits',
  'All water park amenities included',
  'Best value for unlimited visits'
];

export const LATE_CHECKOUT_PACKAGES_CODES = ['2LCOSTAN', '2LCOTHEM', '2LCOPREM'];

export const HOWL_N_LEARN_CODE = 'HOWLEARN';

export const CHECKOUT_TIMES = {
  AM_11: '11 a.m.',
  PM_1: '1 p.m.',
  PM_2: '2 p.m.'
};

export const RESERVATION_TYPE = {
  DAYPASS: 'daypass',
  SEASONPASS: 'seasonpass',
  SUITE: 'suites'
};

// Analytics related constants
export const EVENT_PARAMS = {
  fbEventId: 'x-fb-event_id'
};

export const PRODUCT_SCOPES = {
  suiteCheckout: 'suite-checkout',
  postPurchase: 'post-purchase',
  productImpressions: 'product-impressions',
  productClick: 'product-click',
  addToCart: 'add-to-cart',
  standardPurchase: 'standard purchase'
};

export const EVENT_CATEGORIES = {
  GTM: {
    transaction: 'transaction',
    purchasePackage: 'purchasePackage',
    purchaseSuite: 'purchaseSuite',
    checkoutOption: 'checkoutOption',
    modifyError: 'modify-error',
    postPurchasePackage: 'postPurchasePackage',
    fbPurchase: 'fbPurchase',
    signIn: 'SignIn',
    passwordChange: 'PasswordChange',
    signUp: 'SignUp',
    leadgen: 'LeadGen',
    checkoutStep: 'checkout-step',
    addToCart: 'add-to-cart',
    removeFromCart: 'remove-from-cart',
    postPurchase: 'post-purchase',
    packages: 'packages',
    search: 'search',
    rateCalendar: 'rate-calendar',
    daypassPackagePurchase: 'daypassPackagePurchase',
    passPackagePurchasesVariationA: 'passPackagePurchasesVariationA',
    passPackagePurchasesVariationB: 'passPackagePurchasesVariationB',
    customView: 'custom_view',
    suiteCheckout: 'suite-checkout',
    daypass: 'daypass'
  },
  INTERACTIONS: {
    postReservation: 'InteractionStudioReservation'
  }
};

export const GTM_EVENT = {
  NAME: {
    websiteVitals: 'WebsiteVitals',
    daypassDiningPackagePurchase: 'daypassDiningPackagePurchase',
    passPurchase: 'passPackagePurchase',
    signInAttempt: 'sign_in_attempt',
    signInSuccess: 'sign_in_success',
    signInFailure: 'sign_in_failure',
    signUpAttempt: 'sign_up_attempt',
    signUpSuccess: 'sign_up_success',
    signUpFailure: 'sign_up_failure'
  },
  ACTION: {
    signInAttempt: 'SignInAttempt',
    signInSuccess: 'SignInSuccess',
    signInFailure: 'SignInFailure',
    signUpAttempt: 'SignUpAttempt',
    signUpFailure: 'SignUpFailure',
    signUpAttemptRaF25: 'SignUpAttemptReferral25Group',
    signUpAttemptRaF50: 'SignUpAttemptReferral50Group',
    signUpSuccess: 'SignUpSuccess',
    signUpSuccessRaF25: 'SignUpSuccessReferral25Group',
    signUpSuccessRaF50: 'SignUpSuccessReferral50Group',
    leadGenSuccess: 'LeadGenSuccess',
    passwordChangeRequest: 'PasswordChangeRequest',
    passwordChangeAttempt: 'PasswordChangeAttempt',
    passwordChangeSuccess: 'PasswordChangeSuccess',
    passwordChangeFailure: 'PasswordChangeFailure',
    openRateCalendar: 'OpenRateCalendar',
    closeRateCalendar: 'CloseRateCalendar',
    daypassPurchaseVersionB: 'DaypassPurchaseVersionB',
    daypassPurchaseVersionC: 'DaypassPurchaseVersionC',
    daypassPurchaseVersionD: 'DaypassPurchaseVersionD'
  },
  LABEL: {
    greatWolf: 'Great Wolf',
    facebook: 'Facebook',
    google: 'Google',
    apple: 'Apple',
    greatWolfLowerCase: 'great wolf'
  },
  PURCHASE_LOCATION: {
    post_package_purchase: 'post package purchase',
    standard_purchase: 'standard purchase',
    pre_checkin: 'pre checkin',
    post_purchase_daypass: 'post purchase - daypass'
  }
};

export const POLICY_TYPES = {
  FLEXIBLE: 'flexible',
  STANDARD: 'standard'
};

export const POST_ACCOUNT_USER_NOT_FOUND = 'POST_ACCOUNT_USER_NOT_FOUND';

export const DATE_FORMATS = {
  default: 'YYYY-MM-DD',
  defaultWithSlash: 'YYYY/MM/DD',
  monthDayYearLeadingZeros: 'MM/DD/YYYY',
  displayFormat: 'LT',
  formatDayMoreDetailed: 'ddd, MMM DD',
  formatMonthDate: 'MMM. DD',
  formatMonthDateNoDot: 'MMM DD',
  formatMonthDateShortDay: 'MMM D',
  formatMonthLetterDate: 'MMMM DD',
  formatMonthLetterDateOneDigit: 'MMMM D',
  formatDayEvenMoreDetailed: 'dddd, MMMM, D, YYYY',
  monthDayFormat: 'MM/DD',
  dayMonthYearFormat: 'DD/MM/YYYY',
  monthLetterDayYear: 'MMM. DD, YYYY',
  monthLetterDayYearNoDot: 'MMM DD, YYYY',
  formatDay: 'DD',
  numberFormat: 'YYYYMMDDHHmmss',
  monthName: 'MMMM',
  weekMonthYear: 'ddd, MMM DD, YYYY',
  monthDayYear: 'MMM DD, YYYY',
  dayMonthShortYearFormat: 'MM/DD/YY',
  shortDateFormatWithWeekday: 'ddd, MMM D, YYYY',
  dayNameMonthDayYear: 'ddd. MMM D, YYYY',
  monthLongDayCommaYear: 'MMMM D, YYYY',
  monthLongDay: 'MMMM D',
  shortMonthDayYear: 'MMM D, YYYY',
  monthAbbrev: 'MMM'
};

export const TALL_MODAL = 'tall-modal';
export const SHORT_MODAL = 'short-modal';

// Suite image URL.
export const CONFETTI_ANIMATION_URL = getAssetsUrl(ASSETS_LOCATIONS.ANIMATION, 'colorful-confetti.json');

export const PRIVACY_POLICY = `/terms#privacy-policy`;
export const CALIFORNIA_POLICY = '/your-california-privacy-rights#nofi';
export const TERMS_AND_CONDITIONS_SUFFIX = `/terms`;
export const TERMS_AND_CONDITIONS_ACCOUNT_CREATION = '/terms';

export const MAX_GUESTS_COUNT = 8;

export const DAY_PASSES_TYPE = {
  halfDay: 'WPHLF',
  fullDay: 'WPFULL',
  roomType: 'WPPASS'
};

export const DAY_PASSES_NAMES = {
  FULL_DAY_PASS: 'Full Day Pass',
  HALF_DAY_PASS: 'Half Day Pass'
};

export const DAY_PASSES_ROOM_TYPE = {
  WPHLF: 'half',
  WPFULL: 'full'
};

export const CABANAS_CODES_TYPES = {
  indoor: 'CBINDR',
  outdoor: 'CBOTDR',
  group: 'CA'
};

export const PACKAGES_MESSAGES = {
  packageNotAvailable: 'Package Not Available'
};

export const LODGE_CONFIG_TYPES = {
  IDME_WIDGET: 'idme-widget',
  LOYALTY: 'loyalty',
  PLAN: 'plan',
  DAYPASS: 'daypass',
  CREDIT_PACKAGES: 'credit-packages',
  CMP: 'cmp',
  PAYMENT: 'payment',
  LEAD_GEN: 'lead-gen',
  CART: 'cart',
  BOOKING_WIDGET: 'booking-widget',
  BDAY_BOOKING_WIDGET: 'bday-booking-widget',
  PROFILE: 'profile'
};

export const PACKAGE_TYPE = {
  dining: 'dining',
  pass: 'Pass',
  activity: 'activity',
  birthday: 'Birthday',
  cabanasAndFlexTrip: 'cabana',
  main: 'main',
  attractions: 'attractions',
  flexTrip: 'FLEXTRIP',
  lateCheckOut: 'late-checkout',
  parking: 'parking',
  bundle: 'bundle',
  default: 'Default',
  'default-single-pkg': 'default-single-pkg', //adventure pass
  favorite: 'favorite'
};

export const PACKAGE_CHARGE_TYPE = {
  personPerDay: 'person/day',
  byPackage: 'by package'
};

export const PACKAGES_CATEGORY = {
  dining: 'Dining',
  activities: 'Activities'
};

// Add only those currency code which we want to show as a price text
export const CURRENCY_CODE = {
  CAD: 'CAD' // currency code for canadian dollar
};

export const RECOMMENDED_FOR_YOU = 'REC_FOR_YOU';

export const MASK = '(000) 000-0000';
export const MASK_WITH_COUNTRY_CODE = '0 (000) 000-0000';
export const PHONE_MASK_REGEX = /\(|\)|-|\s/g;
export const ONLY_DIGITS_REGEX = /\D/g;
export const NATIONAL_NUMBER_DIGITS = 10;
const PHONE_MASK_NATIONAL = ['(', /[1-9]/, /\d/, /\d/, ')', ' ', /\d/, /\d/, /\d/, '-', /\d/, /\d/, /\d/, /\d/];
const PHONE_MASK_WITH_COUNTRY_CODE = [/[1-9]/, ' ', ...PHONE_MASK_NATIONAL];

const digitsIn = value => String(value || '').replace(ONLY_DIGITS_REGEX, '');

export const PHONE_MASK_FOR_MASKED_FIELD = rawValue =>
  digitsIn(rawValue).length > NATIONAL_NUMBER_DIGITS ? PHONE_MASK_WITH_COUNTRY_CODE : PHONE_MASK_NATIONAL;

export const OFFER_CODE_TYPE = {
  group: 'GROUP'
};

export const GUARANTEE_TYPE = {
  advancePayment: 'ADV',
  checkInPayment: 'CCG'
};

// Type of response, success or error
export const NOTIFICATION_TYPE = {
  success: 'success',
  failed: 'error'
};

export const NEW_DAYS_TO_ADD = 5; // Days to add when an old date is entered in plan

export const SUITE_TYPES = {
  unknown: 'UNKNOWN',
  standard: 'standard',
  themed: 'themed',
  premium: 'premium',
  condo: 'condo'
};

export const BACKEND_PAYMENT_TYPES = {
  Affirm: 'AF'
};

export const PACKAGES_TITLE = {
  inclusiveMeal: 'Inclusive Meal'
};

/**
 * If any package has packageGrouo equal toa ny of these values, it should be
 * grouped by the packageGroup instead of the packageCode.
 *
 * Example:
 * const packages = [
 *   {
 *      "description": "B/L Breakfast FOOD",
 *      "packageCode": "BFSTFOOD2",
 *      "packageGroup": "BKFTLNCH",
 *   },
 *   {
 *      "description": ""B/L Breakfast GRAT",
 *      "packageCode": "BFSTFOOD2",
 *      "packageGroup": "BKFTLNCH",
 *   }
 * ]
 *
 * These packages belong to 'BKFTLNCH' packageCode hence, they should be grouped
 * into BKFTLNCH code to be able to calculate rates.
 */
/**
 * Rate Calendar Day Status Types
 */
export const RATE_CAL_DAY_STATUS = {
  available: 'AVAILABLE',
  checkout: 'CHECKOUT',
  unavailable: 'UNAVAILABLE'
};

/**
 * Sorting types
 * @enum {string}
 */
export const SORTING_CRITERIA = {
  descending: 'desc',
  ascending: 'asc',
  recommendedForYou: 'rec'
};

/** Time used to display the Lead Gen modal */
export const LEADGEN_MODAL_DISPLAY_TIME = 30000;

export const ProgressBarStatus = {
  COMPLETED: 'completed',
  PENDING: 'pending',
  ACTIVE: 'active'
};

/**Mobile app download page url */
export const MobileAppPageUrl = '/mobile-app';

/** Customer contact center phone number */
export const CUSTOMER_CONTACT_CENTER_NUM = '800-905-9653';

export const PERSONALIZATION_RULES = {
  interactions: 4
};

export const PERSONALIZATION_PACKAGE_RULES = {
  interactions: 1
};

export const APPLE_SIGN_IN_SUCCESS_EVT = 'AppleIDSignInOnSuccess';
export const APPLE_SIGN_IN_FAILURE_EVT = 'AppleIDSignInOnFailure';

export const ROOM_RATES_ERROR_TITLE = 'An error has occurred';
export const ROOM_RATES_ERROR_MSG = 'Sorry, Rooms for selected dates are not available, please check other dates';
export const ROOM_RATES_DATES_EXCEEDED_ERROR_MSG =
  'Sorry, we are unable to process reservations of longer than one month. Please go back and try again.';
export const SUITE_ERROR_MSG = 'SOME ERRORS OCCURRED';

export const COSTSUMMARY_TOOLTIP = {
  sustainabilityFee:
    'Great Wolf Lodge Arizona is located in the Salt River Pima - Maricopa Indian Community and is subject to a Sustainability Fee charged by SRPMIC equal to 3% of sales. SRPMIC allocates these revenues to support its seven generation stewardship and related initiatives. Please see our FAQ page for further details.',
  resortFee:
    'The Resort Fee includes services that are often charged individually, including water park amenities life jackets and towels, resort-wide wireless internet, virtual concierge service, in-room amenities such as a coffee maker and mini-fridge, and perks unique to Great Wolf Lodge like complimentary arts & craft projects provided during select kids’ entertainment programs.'
};

//Interaction Studio will track a user's behavior with help of these fixed class names
export const IS_CLASSES = {
  packageContainer: 'sfis-package-container',
  packagePrice: 'sfis-package-price',
  suiteContainer: 'sfis-suite-container',
  suiteDetails: 'sfis-suite-details',
  roomPrice: 'sfis-suite-price'
};

export const CHECK_IN_STATUS = {
  AVAILABLE: 'available',
  UNAVAILABLE: 'unavailable',
  SUCCESSFUL: 'successful',
  INVALID: 'invalid'
};

//Some packageCodes aren't supposed to show person by price labels
export const PACKAGES_WITHOUT_CHARGE_TYPE = ['BFSTFOOD', 'BFSTFOOD1', 'BREAKFAST'];

export const USER_PATCH_OPERATIONS = {
  ADD: 'add',
  EDIT: 'replace',
  REMOVE: 'remove'
};

export const SUPPORTED_COUNTRIES = {
  UnitedStates: 'US',
  Canada: 'CA'
};

export const VALID_COUNTRIES = [SUPPORTED_COUNTRIES.UnitedStates, SUPPORTED_COUNTRIES.Canada];

export const TOOLTIP_DIRECTION = {
  right: 'right',
  left: 'left'
};

export const TOOLTIP_POSITION = {
  top: 'top',
  topLeft: 'top-left',
  topRight: 'top-right',
  bottom: 'bottom',
  bottomLeft: 'bottom-left',
  bottomRight: 'bottom-right'
};

export const TOOLTIP_POSITIONS = {
  tops: [TOOLTIP_POSITION.top, TOOLTIP_POSITION.topLeft, TOOLTIP_POSITION.topRight],
  bottoms: [TOOLTIP_POSITION.bottom, TOOLTIP_POSITION.bottomLeft, TOOLTIP_POSITION.bottomRight]
};

export const PAYMENT_METHODS_ICONS = 'https://cdn.greatwolf.com/content/png/';

export const STATIC_CDN = 'https://cdn.greatwolf.com/content/png/';

export const TAXES = 'Taxes';
export const PARKING_FEE = 'Parking Fee';
export const RESORT_FEE = 'Resort Fee';
export const SUSTAINABILITY_FEE = 'Sustainability Fee';
export const PRIVATE_LODGING_FEE = 'Private Lodging Fee';

export const CALENDAR_RESTRICTIONS_TYPES = {
  CLOSE: 'CLOSE',
  CLOSE_TO_ARRIVAL: 'CLOSE_TO_ARRIVAL',
  CLOSE_TO_DEPARTURE: 'CLOSE_TO_DEPARTURE',
  MIN_LENGTH_OF_STAY_ON_ARRIVAL: 'MIN_LENGTH_OF_STAY_ON_ARRIVAL',
  MIN_LENGTH_OF_STAY: 'MIN_LENGTH_OF_STAY'
};

export const SUITE_AVAILABILITY_TYPES = {
  AVAILABLE_TYPE: 'AVAILABLE_TYPE',
  UNAVAILABLE_TYPE: 'UNAVAILABLE_TYPE'
};

export const PARKING_PACKAGE_CODE = 'PARKING';

export const CONNECTICUT = 'MASHCT';

export const ROOM_FARE_FAMILY_RATE_TYPE = {
  nonMember: 'NON-MEMBER',
  voyager: 'VOYAGER'
};

export const PAYMENT_ERROR_MESSAGES = {
  default: 'Oops - we had a problem with processing the information.',
  OWS_SYSTEM_ERROR: `Unfortunately, there is been an error processing your credit card. Please contact our call center at ${CUSTOMER_CONTACT_CENTER_NUM} in order to complete your reservation`,
  CREDIT_CARD_AUTHORIZATION_FAILED: 'Credit card authorization has failed. Please check the numbers and try again.',
  PAYPAL_AUTHORIZATION_FAILED:
    'PayPal authorization has failed. Please select a different payment method and try again.',
  INVALID_CREDIT_CARD_EXPIRATION: 'The credit card expiration date is invalid. Please check the numbers and try again.',
  INVALID_RATE_CODE_FOR_PROMOTION_CODE:
    'The Offer Code you have entered does not match the Rate Code, this may be caused by multiple browser tabs opened to the Great Wolf website. Please close additional tabs and try your booking again.',
  RATE_CODE_NOT_AVAILABLE:
    'The Offer Code you have entered is no longer valid, please visit our deals page to find our latest offers.',
  ROOM_UNAVAILABLE:
    'We apologize for the inconvenience, but the room you are trying to book is no longer available, please go back and select another room type.',
  RATES_MISMATCH:
    'We apologize for the inconvenience, but the rates of the room you are trying to book has changed, please note cost summary has been updated with the new rates',
  PRICING_KEY_NOT_FOUND:
    'Booking availability has expired. To proceed with your booking, please return to the suites page and start again.',
  AVAILABILITY_KEY_NOT_FOUND:
    'Booking availability has expired. To proceed with your booking, please return to the suites page and start again.',
  AVAILABILITY_KEY_NOT_FOUND_DAYPASS:
    'Booking availability has expired. To proceed with your booking, please return to the daypass page and start again.',
  NO_INVENTORY_FOR_SELECTED_SUITE:
    "We're sorry—the suite you are attempting to book is no longer available. Please select a different suite from the available options.",
  NO_INVENTORY_FOR_SELECTED_DAYPASS:
    "We're sorry—the suite you are attempting to book is no longer available. Please select a different date from the available daypass dates options.",
  VOUCHER_ALREADY_REDEEMED: 'This voucher has already been redeemed.',
  VOUCHER_EXPIRED: 'This voucher is no longer valid.',
  VOUCHER_INVALID: 'The voucher code is invalid or does not match the booking details.'
};

export const VOYAGERS_LP = '/voyagers-club';

export const API_STATUS = {
  IDLE: 'IDLE',
  LOADING: 'LOADING',
  SUCCEEDED: 'SUCCEEDED',
  ERROR: 'ERROR'
};

export const WRITE_LOCAL_STORAGE_DEBOUNCE_TIMEOUT = 100; // 100ms
export const CLEAR_LOCAL_STORAGE_DEBOUNCE_TIMEOUT = 3600000 * 24; // 24 hrs (1h = 3600000ms)

export const BIRTHDAY_COMPARISON_CHART_CLASS = 'birthday-parties-comparison-chart';
export const BIRTHDAY_FAQ_CLASS = 'faq-one-page';
export const SEASONPASS_HERO_BANNER_CLASS = 'hero-freeform-banner';
export const SEASONPASS_FAQ_CLASS = 'column-container';

export const SEARCH_TYPES = {
  reservation: 'reservation',
  promoSearch: 'reservation – promo search',
  aiPlanner: 'reservation – AI planner'
};

export const CUSTOM_PURCHASE_LOCATIONS = {
  standardPurchase: 'standard purchase',
  planPageModal: 'standard purchase - plan page modal',
  cart: 'standard purchase - cart',
  videoModal: 'standard purchase - video modal',
  birthdayParty: 'standard purchase - birthday party',
  cmpConfirmationModal: 'post purchase - confirmation pop up',
  dayassCmpConfirmationModal: 'post purchase - daypass confirmation pop up',
  modifyReservationUpgradeSuite: 'modify reservation - upgrade suite'
};

export const WEEKDAY_TYPE = 'WEEKDAY';
export const ANYTIME_TYPE = 'ANYTIME';

export const MODAL_KEYS = {
  INFO_CARD_DETAILS_MODAL: 'INFO_CARD_DETAILS_MODAL',
  FIND_RESERVATION_BY_ID: 'FIND_RESERVATION_BY_ID',
  AUTH_MODAL: 'AUTH_MODAL',
  LEAD_GEN_MODAL: 'LEAD_GEN_MODAL',
  IE_MODAL: 'IE_MODAL',
  OFFER_CODE_ERROR_TOAST: 'OFFER_CODE_ERROR_TOAST',
  PACKAGE_MODAL: 'PACKAGE_MODAL',
  SMS_SIGN_UP_MODAL: 'SMS_SIGN_UP_MODAL',
  SPECIAL_REQUEST_MODAL: 'SPECIAL_REQUEST_MODAL',
  RECENT_SEARCHES: 'RECENT_SEARCHES',
  CONFETTI_MODAL: 'CONFETTI_MODAL',
  DINING_CREDIT_MODAL: 'DINING_CREDIT_MODAL',
  ATTRACTIONS_INFO_MODAL: 'ATTRACTIONS_INFO_MODAL',
  CMP_ADD_GUESTS_MODAL: 'CMP_ADD_GUESTS_MODAL',
  PARKING_BANNER_MODAL: 'PARKING_BANNER_MODAL',
  CART_MODIFY_MODAL: 'CART_MODIFY_MODAL',
  WATER_PARK_PASSES_VIDEO_MODAL: 'WATER_PARK_PASSES_VIDEO_MODAL',
  BIRTHDAY_CONFIRMATION_MODAL: 'BIRTHDAY_CONFIRMATION_MODAL',
  SUITE_UPGRADE_OFFERS_MODAL: 'SUITE_UPGRADE_OFFERS_MODAL'
};
